let copyrightElements: Element[] = [];

export function activateCopyright() {
    const copyrights = document.getElementsByClassName("copyright--text");

    for (const copyright of Array.from(copyrights)) {
        if (copyright instanceof HTMLElement) {
            copyright.addEventListener("click", toggleCopyright);
            copyrightElements.push(copyright);
        }
    }
}

function toggleCopyright(e: MouseEvent) {
    e.preventDefault();
    e.stopPropagation();

    if (e.currentTarget instanceof HTMLElement && e.target instanceof HTMLButtonElement) {
        e.currentTarget.classList.toggle("copyright--text-open");
    }
}

export function reloadCopyright() {
    for (const copyright of copyrightElements) {
        if (copyright instanceof HTMLElement) {
            copyright.removeEventListener("click", toggleCopyright);
        }
    }

    copyrightElements = [];
    activateCopyright();
}
